var map = {
	"./anhui.json": "./found/views/mdm/views/customer_distribution/map/json/province/anhui.json",
	"./aomen.json": "./found/views/mdm/views/customer_distribution/map/json/province/aomen.json",
	"./beijing.json": "./found/views/mdm/views/customer_distribution/map/json/province/beijing.json",
	"./chongqing.json": "./found/views/mdm/views/customer_distribution/map/json/province/chongqing.json",
	"./fujian.json": "./found/views/mdm/views/customer_distribution/map/json/province/fujian.json",
	"./gansu.json": "./found/views/mdm/views/customer_distribution/map/json/province/gansu.json",
	"./guangdong.json": "./found/views/mdm/views/customer_distribution/map/json/province/guangdong.json",
	"./guangxi.json": "./found/views/mdm/views/customer_distribution/map/json/province/guangxi.json",
	"./guizhou.json": "./found/views/mdm/views/customer_distribution/map/json/province/guizhou.json",
	"./hainan.json": "./found/views/mdm/views/customer_distribution/map/json/province/hainan.json",
	"./hebei.json": "./found/views/mdm/views/customer_distribution/map/json/province/hebei.json",
	"./heilongjiang.json": "./found/views/mdm/views/customer_distribution/map/json/province/heilongjiang.json",
	"./henan.json": "./found/views/mdm/views/customer_distribution/map/json/province/henan.json",
	"./hubei.json": "./found/views/mdm/views/customer_distribution/map/json/province/hubei.json",
	"./hunan.json": "./found/views/mdm/views/customer_distribution/map/json/province/hunan.json",
	"./jiangsu.json": "./found/views/mdm/views/customer_distribution/map/json/province/jiangsu.json",
	"./jiangxi.json": "./found/views/mdm/views/customer_distribution/map/json/province/jiangxi.json",
	"./jilin.json": "./found/views/mdm/views/customer_distribution/map/json/province/jilin.json",
	"./liaoning.json": "./found/views/mdm/views/customer_distribution/map/json/province/liaoning.json",
	"./neimenggu.json": "./found/views/mdm/views/customer_distribution/map/json/province/neimenggu.json",
	"./ningxia.json": "./found/views/mdm/views/customer_distribution/map/json/province/ningxia.json",
	"./qinghai.json": "./found/views/mdm/views/customer_distribution/map/json/province/qinghai.json",
	"./shandong.json": "./found/views/mdm/views/customer_distribution/map/json/province/shandong.json",
	"./shanghai.json": "./found/views/mdm/views/customer_distribution/map/json/province/shanghai.json",
	"./shanxi.json": "./found/views/mdm/views/customer_distribution/map/json/province/shanxi.json",
	"./shanxi1.json": "./found/views/mdm/views/customer_distribution/map/json/province/shanxi1.json",
	"./sichuan.json": "./found/views/mdm/views/customer_distribution/map/json/province/sichuan.json",
	"./taiwan.json": "./found/views/mdm/views/customer_distribution/map/json/province/taiwan.json",
	"./tianjin.json": "./found/views/mdm/views/customer_distribution/map/json/province/tianjin.json",
	"./xianggang.json": "./found/views/mdm/views/customer_distribution/map/json/province/xianggang.json",
	"./xinjiang.json": "./found/views/mdm/views/customer_distribution/map/json/province/xinjiang.json",
	"./xizang.json": "./found/views/mdm/views/customer_distribution/map/json/province/xizang.json",
	"./yunnan.json": "./found/views/mdm/views/customer_distribution/map/json/province/yunnan.json",
	"./zhejiang.json": "./found/views/mdm/views/customer_distribution/map/json/province/zhejiang.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./found/views/mdm/views/customer_distribution/map/json/province sync recursive ^\\.\\/.*\\.json$";